import {
  Component,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef, OnDestroy
} from '@angular/core';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {Icontext} from "@ispm-client/modules/aggregator/interfaces";
import {IResource} from "@ispm/core/interfaces/resource.interface";
import {AgregationService} from "@ispm-client/modules/aggregator/services";
import {get, isEqual} from "lodash";
import {of, Subject} from "rxjs";


interface IReferencePayload {
  referenceType: 'string' | 'reference';
  resourceType: string;
  itemConfig?:  IdynamicFormItem[];
  pathToSource?: string;
  preventClientTransformation?: string; // prevent transformation to reference from client side
  formId?: string;
}

@Component({
  selector: 'ispm-reference-resolver',
  templateUrl: './reference-resolver.component.html',
  styleUrls: ['./reference-resolver.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ReferenceResolver')
export class ReferenceResolverComponent implements AfterViewInit , IWidgetItem<IReferencePayload>, OnDestroy {
  public config: any;
  public restForm: boolean = false;
  public data: any;
  public widgetConfigPayload: IReferencePayload = { referenceType : 'string',resourceType:'',itemConfig:[{} as IdynamicFormItem]};
  public widgetUpdateValueCallback: (value: any) => void ;
  public listenToDataChange = true;
  public fromId: string;
  private _widgetDisabledStatus: boolean;
  private _widgetFormInstanceSubmitted: boolean;
  private _lastData: string | Icontext;
  private destroyed$: Subject<any> = new Subject();


  ngAfterViewInit(): void {
    const fieldName = this.widgetConfigPayload.pathToSource;
    if (fieldName) {
      this.data = { };
      this.data[fieldName] = { };
    } else {
      this.data = { };
    }
  }

  constructor(private _changeDetector: ChangeDetectorRef, private _aggregatorService: AgregationService) {

  }

  set widgetData(widgetData: string | Icontext) {
    if (!widgetData) { return; } // skip if widget data is null
    if (!isEqual(widgetData, this._lastData)) {
      this._lastData = widgetData;
      this._fromReference(widgetData)
        .takeUntil(this.destroyed$.asObservable())
        .subscribe(
        value => {
          const fieldName = this.widgetConfigPayload.itemConfig[0].name;
          if (this.data === undefined) {
            this.data = { }; }
          const objectForForm =  {
            'id': value[0].ReferenceResolverComponent.id,
            'name': value[0].ReferenceResolverComponent.name
          };
          if (fieldName) {
            this.data[fieldName] = objectForForm;
          } else {
            this.data = objectForForm;
          }
          this.data = {...this.data};
          this._changeDetector.markForCheck();
          this._changeDetector.detectChanges();
        });
    }
  }

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    this.widgetConfigPayload.itemConfig = widgetConfig.widgetPayload.itemConfig;
    this.config = widgetConfig.widgetPayload.itemConfig;
    this.fromId = widgetConfig.widgetPayload.formId;
    this.widgetConfigPayload = widgetConfig.widgetPayload;
  }

  updateSearchObject(form, isFormInit: boolean = false) {
    if (!isFormInit) {
      this.widgetUpdateValueCallback.apply(this, [this._toReference(form)]);
    }
  }
  public get widgetFormInstanceSubmitted() {
    return this._widgetFormInstanceSubmitted;
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  }

  set widgetDisabledStatus(value) {
    this._widgetDisabledStatus = value;
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  get widgetDisabledStatus() {
    return this._widgetDisabledStatus;
  }

  private _toReference(data: IResource): Icontext | string | IResource {
    if (!this.widgetConfigPayload.pathToSource) {
      return data;
    }
    const resource = get(data, this.widgetConfigPayload.pathToSource);
    if (!resource) {
      console.log('reference Resolver found no data in form');
      return null;
    }
    if(this.widgetConfigPayload.preventClientTransformation){
      return resource;
    }

    switch (this.widgetConfigPayload.referenceType.toLowerCase()) {
      case 'string':
        return resource.id;
      case 'reference':
      default:
        return { resourceType: resource.resourceType, reference: resource.id};
    }
  }
  private  _fromReference(data: string | Icontext) {
    if(!data){
      return of(null);
    }
    let resourceType, reference;
    switch (this.widgetConfigPayload.referenceType.toLowerCase()) {
      case 'string':
        resourceType = this.widgetConfigPayload.resourceType;
        reference = data;
        break;
      case 'reference':
        resourceType = (<Icontext> data).resourceType;
        reference = (<Icontext> data).reference;
        break;
    }
    if(!(reference && resourceType)){
      return of(null)
    }
    const response =  this._aggregatorService.registerQuery([{
      formId: this.constructor.name,
      identifier: this.constructor.name,
      targetResource: resourceType,
      isContextNeeded: false,
      queryString: '_id=' + reference}]);
    return response;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
